// 운영 대시보드 공용 상수·도메인 라벨 — 헤더/KPI/차트가 함께 쓴다.

// 한국어 상태 라벨. 의미색은 statusColor()와 일관.
const STATUS_LABEL: Record<string, string> = {
    pending: '대기',
    queued: '대기',
    processing: '처리 중',
    collecting: '수집 중',
    scored: '채점 완료',
    reported: '보고서 발행',
    completed: '완료',
    done: '완료',
    success: '성공',
    failed: '실패',
    error: '오류',
    rejected: '반려',
}

export const statusLabel = (k: string) => STATUS_LABEL[k] ?? k

export type View = 'stats' | 'timeseries'
export const PERIODS = [7, 30, 90] as const
export const PERIOD_LABEL: Record<number, string> = {
    7: '7일',
    30: '30일',
    90: '90일',
}

// 기간 라벨 — 정의된 값이면 매핑, 아니면 "n일".
export const formatPeriodLabel = (days: number) =>
    PERIOD_LABEL[days] ?? `${days}일`
